(function(global) {

	function mapLoaded() {
		store.mapLoaded = true;
	}

	global.SearchApp_mapLoaded = mapLoaded;

})(window);
